// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-user.modal .ui.checkbox {
  width: 100%;
  margin-top: 5px;
}

.web-user.modal .ui.checkbox.admin {
  margin-bottom: 10px;
  font-weight: bold;
}

.settings-layout .system.logging .log-section.active {
  background-color: whitesmoke;
}

.settings-layout .system.logging .sections {
  margin-top: 25px !important;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Settings/routes/System/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".web-user.modal .ui.checkbox {\n  width: 100%;\n  margin-top: 5px;\n}\n\n.web-user.modal .ui.checkbox.admin {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.settings-layout .system.logging .log-section.active {\n  background-color: whitesmoke;\n}\n\n.settings-layout .system.logging .sections {\n  margin-top: 25px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
